import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class IsAdminOrLocalAdminGuard {
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return localStorage.getItem('role') === 'LocalAdmin' || localStorage.getItem('role') === 'Admin';
  }
}
